import { render } from "./WithLabel.vue?vue&type=template&id=1b94f34b&scoped=true"
import script from "./WithLabel.vue?vue&type=script&lang=js"
export * from "./WithLabel.vue?vue&type=script&lang=js"

import "./WithLabel.vue?vue&type=style&index=0&id=1b94f34b&lang=scss&scoped=true"

import exportComponent from "/Users/intr0vert/Git/ai-startup/aibanner/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b94f34b"]])

export default __exports__